import I18n from "common/i18n";
import { WarningMessageBox, ConfirmMessageBox } from "common/elements";

type Props = {
  showVersionWarning: boolean;
  showAmazonWarning: boolean;
  onCloseVersionWarning: () => void;
  onCloseAmazonWarning: () => void;
  onGotoStoreUpdate: () => void;
};

export const UserPlanWarningDialogs = ({
  showVersionWarning,
  showAmazonWarning,
  onCloseVersionWarning,
  onCloseAmazonWarning,
  onGotoStoreUpdate,
}: Props) => {
  return (
    <>
      {showVersionWarning && (
        <ConfirmMessageBox
          title={I18n.t("MSG_USER_PLAN_UPDATE_REQUIRED_TITLE")}
          message={I18n.t("MSG_USER_PLAN_UPDATE_REQUIRED_MESSAGE")}
          close={onCloseVersionWarning}
          confirm={onGotoStoreUpdate}
        />
      )}

      {showAmazonWarning && (
        <WarningMessageBox
          title={I18n.t("MSG_USER_PLAN_AMAZON_NOT_SUPPORTED_TITLE")}
          message={I18n.t("MSG_USER_PLAN_AMAZON_NOT_SUPPORTED_MESSAGE")}
          close={onCloseAmazonWarning}
        />
      )}
    </>
  );
};
